import React, { useState } from "react";
import Button from "../../../components/shared/button";
import { Outlet } from "react-router-dom";
import ContractAddModal from "../../../modals/addContractModal";
import { useTranslation } from "react-i18next";

const ProtectiveMeasures = () => {
  const { t } = useTranslation();
  const [isaddnewModelOpen, setisaddnewModelOpen] = useState(false);
  const oAddNewClick = () => {
    setisaddnewModelOpen(true);
  };
  return (
    <>
      <div className="main-div py-[55px] flex flex-col gap-[16px]">
        <div className="top flex items-center justify-between gap-[16px]">
          <h5 className="text-blue font-bold">{t("dashboard.protectiveMeasures.title")}</h5>
          {/* <Button
            text={t("dashboard.protectiveMeasures.addNew")}
            className="button btn-blue !rounded-[29px] medium"
            height={45}
            width={137}
            img="line-md:plus"
            clr="white"
            onClick={oAddNewClick}
          /> */}
        </div>
        <Outlet />
      </div>
      <ContractAddModal
        isaddnewModelOpen={isaddnewModelOpen}
        setisaddnewModelOpen={setisaddnewModelOpen}
      />
    </>
  );
};

export default ProtectiveMeasures;
